<script>
    export let id;
    export let text;
    export let value;
</script>

<label for="{id}">{text}</label>
<input id="{id}" name="{id}" type="text" bind:value={value}>